import { CallLogsPayload, updateTypeCallLogs } from "src/interfaces";
import { apiBaseUrl as baseUrl, fetch as http } from "./http";
import axios from "axios";
// export const fetchCallLogsService = async (page: number = 1) => {
//   try {
//     let query = `page=${page}`;
//     const url = `/call-logs?${query}`;
//     const data = await http.Get(url);
//     return data;
//   } catch (error: any) {
//     throw new Error(error);
//   }
// };

// export const fetchCallLogsService = async (filters: CallLogsPayload = {}) => {
//   try {
//     const queryParts: string[] = [];

//     Object.entries(filters).forEach(([key, value]) => {
//       if (value == null) return;

//       // Handle agentIds
//       if (key === "agentIds") {
//         if (Array.isArray(value) && value.length > 0) {
//           queryParts.push(`agentIds=${value.join(",")}`);
//         } else {
//           queryParts.push(`agentIds=`);
//         }
//         return;
//       }

//       if (value === "") {
//         queryParts.push(`${key}=`);
//         return;
//       }

//       queryParts.push(`${key}=${value}`);
//     });

//     const query = queryParts.join("&");
//     const url = `/call-logs?${query}`;

//     const response = await http.Get(url);

//     return response;
//   } catch (error) {
//     throw new Error("Failed to fetch call logs");
//   }
// };

export const fetchCallLogsService = async (filters: CallLogsPayload = {}) => {
  try {
    const queryParts: string[] = [];

    Object.entries(filters).forEach(([key, value]) => {
      if (key === "agent_ids") {
        if (Array.isArray(value) && value.length > 0) {
          queryParts.push(`agent_ids=[${value}]`);
        } else {
          queryParts.push(`agent_ids=[]`);
        }
        return;
      }
      if (value !== null && value !== undefined) {
        queryParts.push(`${key}=${encodeURIComponent(String(value))}`);
      }
    });

    const query = queryParts.join("&");
    const url = `/call-logs?${query}`;

    return await http.Get(url);
  } catch (error) {
    throw new Error("Failed to fetch call logs");
  }
};

export const fetchIvrMenusService = async () => {
  try {
    const url = `/ivr-menus`;
    const data = await http.Get(url);
    return data;
  } catch (error: any) {
    throw new Error(error);
  }
};

export const fetchSyncIvrMenusService = async () => {
  try {
    const url = `/sync-ivr-menus`;
    const data = await http.Get(url);
    return data;
  } catch (error: any) {
    throw new Error(error);
  }
};

export const fetchSyncExtensionsService = async () => {
  try {
    const url = `/sync-extensions`;
    const data = await http.Get(url);
    return data;
  } catch (error: any) {
    throw new Error(error);
  }
};

export const fetchCustomerInfoService = async (payload: string | number) => {
  try {
    const url = `${baseUrl}/fetch-customer-info/${payload}`;
    const data = await axios.get(url);
    return data;
  } catch (error: any) {
    throw new Error(error);
  }
};

export const fetchPostCallCustomer = async (sessionId: string = "") => {
  try {
    const url = `/call_customer/${sessionId}`;
    const data = await http.Get(url);
    return data;
  } catch (error: any) {
    throw new Error("Failed to fetch call queue");
  }
};

export const fetchCallDetailService = async (sessionId: string | number) => {
  try {
    const url = `/call-detail/${sessionId}`;
    const response = await http.Get(url);
    return response;
  } catch (error: any) {
    throw new Error("Failed to fetch call detail");
  }
};

export const updateCallLogService = async (
  sessionId: string | number,
  payload: updateTypeCallLogs,
) => {
  try {
    const url = `/call-update/${sessionId}`;
    const response = await http.Post(url, payload);
    return response;
  } catch (error: any) {
    throw new Error("Failed to update call log");
  }
};

export const updateTransferCallLogService = async (
  payload: { id: string; transfer_remark: string }
) => {
  try {
    const url = `/update_call_transfer_log`;
    const formData = new FormData();
    formData.append("id", payload.id);
    formData.append("transfer_remark", payload.transfer_remark);

    const response = await http.Post(url, payload);
    return response;
  } catch (error: any) {
    throw new Error("Failed to update transfer call log");
  }
};

export const fetchQueueCallsService = async (page: number = 1) => {
  try {
    let query = `page=${page}`;
    const url = `/queue-calls?${query}`;
    const response = await http.Get(url);
    return response;
  } catch (error: any) {
    throw new Error("Failed to fetch call queue");
  }
};

export const fetchQueueTransferCallsService = async (page: number = 1) => {
  try {
    let query = `page=${page}`;
    const url = `/get_pending_remarks_transfer_calls?${query}`;
    const response = await http.Get(url);
    return response;
  } catch (error: any) {
    throw new Error("Failed to fetch call queue");
  }
};

export const fetchTotalCountsQueueCallsService = async () => {
  try {
    const url = `/get_pending_remarks_total_counts`;
    const response = await http.Get(url);
    return response;
  } catch (error: any) {
    throw new Error("Failed to fetch call queue");
  }
};

export const fetchCallStatsService = async () => {
  try {
    const url = `/call-stats`;
    const response = await http.Get(url);
    return response;
  } catch (error: any) {
    throw new Error("Failed to fetch call stats");
  }
};

export const fetchCallLogsDetailsService = async (
  sessionId: string | number,
  page: number = 1,
) => {
  try {
    const url = `/call-detail-with-logs/${sessionId}?page=${page}`;
    const response = await http.Get(url);
    return response;
  } catch (error) {
    throw new Error("Failed to fetch call detail");
  }
};

export const exportCallLogsService = async (filters: any = {}) => {
  try {
    const queryParts: string[] = [];

    Object.entries(filters).forEach(([key, value]) => {
      if (key === "agent_ids") {
        if (Array.isArray(value) && value.length > 0) {
          queryParts.push(`agent_ids=[${value}]`);
        } else {
          queryParts.push(`agent_ids=[]`);
        }
        return;
      }
      if (value !== null && value !== undefined) {
        queryParts.push(`${key}=${encodeURIComponent(String(value))}`);
      }
    });

    const query = queryParts.join("&");
    const url = `/export-logs?${query}`;

    // The export endpoint returns a JSON payload with a download_url
    // use normal GET to parse JSON instead of ExportGet which returns a blob
    return await http.Get(url);
  } catch (error) {
    throw new Error("Failed to export call logs");
  }
};

export const fetchCallLogsExtensionService = async () => {
  try {
    const url = `/get-extensions`;
    const response = await http.Get(url);
    return response;
  } catch (error) {
    throw new Error("Failed to fetch calllogs extension");
  }
};


export const fetchCallStatsAnalytics = async (params: any = {}) => {
  try {
    const url = `/call-stats-analytics`;

    // Build the request payload
    const payload = {
      agent_id: params.agent_id || [],
      location: params.location || [],
      start_date: params.start_date || null,
      end_date: params.end_date || null,
    };

    const response = await http.Post(url, payload);

    return response;
  } catch (error: any) {
    const msg =
      error?.response?.data?.message ||
      error?.message ||
      "Failed to fetch call stats analytics";

    throw new Error(msg);
  }
};

export const fetchCallLogsLocationsService = async () => {
  try {
    const url = `/locations`;
    const response = await http.Get(url);
    return response;
  } catch (error: any) {
    const msg =
      error?.response?.data?.message ||
      error?.message ||
      "Failed to fetch locations";

    throw new Error(msg);
  }
};

export const fetchCallLogsAgentsService = async (locationIds: string[] = []) => {
  try {
    // Filter out empty strings and check if we have valid location IDs
    const validLocationIds = locationIds.filter(id => id && id !== "");

    if (validLocationIds.length === 0) {
      return { data: [] };
    }

    const url = `/agents`;

    // Build the request payload
    const payload = {
      location: validLocationIds
    };

    const response = await http.Post(url, payload);
    return response;
  } catch (error: any) {
    const msg =
      error?.response?.data?.message ||
      error?.message ||
      "Failed to fetch agents";

    throw new Error(msg);
  }
};